<div class="container mt-4" *ngIf="isBaseFlow">
  <div class="col-12">
    <ngb-alert
      *ngIf="alert"
      [type]="alert.type"
      (closed)="closeAlert()"
      class="sticky-top"
      style="top: 10px"
    >
      {{ alert.message }}
    </ngb-alert>
    <app-register-stepper [progressData]="getProgressData()" [user]="user"></app-register-stepper>

    <div class="row mb-3 mt-3">
      <div class="col-12">
        <h2 class="text-center">Choose the level of protection to suit you</h2>
      </div>

      <div class="container mt-4">
        <div class="row mb-3 mt-3">
          <div class="col-12">
            <app-pricing-table
              [userCurrentProductType]="userCurrentProductType"
              [hidePrices]="true"
              [disabled]="loading"
              [showShortDescription]="false"
              [showFeatures]="true"
              [pricingPlans]="pricingPlans"
              [user]="user"
              [buttonLabel]="'Learn more'"
              (onSelect)="select($event)"
              [showPromo]="showPromo"
              (onClosePromo)="onClosePromo()"
              (onNavigateToProductPage)="navigateToProductPage($event)"
            ></app-pricing-table>
          </div>
        </div>

        <div
          class="row complete-link-wrapper d-flex justify-content-center"
          [class.promo-open]="showPromo && !promoClosed"
        >
          <span *ngIf="!userAlreadyHasASubscription">Or continue with your basic</span>
          <a
            [routerLink]="[]"
            queryParamsHandling="preserve"
            (click)="completeMembershipSelection()"
            class="complete-link"
            *ngIf="!userAlreadyHasASubscription"
          >
            identibase account
          </a>

          <span *ngIf="userAlreadyHasASubscription">Or continue with your current</span>
          <a
            [routerLink]="[]"
            queryParamsHandling="preserve"
            (click)="continueWithCurrentMembership()"
            class="complete-link"
            *ngIf="userAlreadyHasASubscription"
          >
            {{ currentMembershipName }} membership
          </a>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="!isBaseFlow">
  <div class="container">
    <ngb-alert
      *ngIf="alert"
      [type]="alert.type"
      (closed)="closeAlert()"
      class="sticky-top"
      style="top: 10px"
    >
      {{ alert.message }}
    </ngb-alert>
    <app-register-stepper [progressData]="getProgressData()" [user]="user"></app-register-stepper>
  </div>

  <div class="container">
    <h2 class="text-center">With our lost & found cover you can act immediately – and with our premium plans over 70% of pets are returned home safely</h2>
  </div>
  <div class="d-flex justify-content-center align-items-center flex-column plan-content-container">
    <div class="d-flex plan-card-container">
      <!--    (onNavigateToProductPage)="-->
      <!--    onNavigateToProductPage.emit(PricingTableSubTypes.IDENTIBASEPLUS)-->
      <!--    "-->

      <app-price-card
        [viewOnly]="false"
        [showShortDescription]="false"
        [showInfoLine]="false"
        [showFeatures]="true"
        [buttonLabel]="'Learn more'"
        [hidePrices]="true"
        [planId]="pricingPlans.identibasePlus"
        [userCurrentProductType]="userCurrentProductType"
        (onSelect)="select($event)"
        [highlighted]="false"
        imageUri="/assets/images/pricingTable/identibasePlus.svg"
        planTitle="identibase+"
        [planLongSubtitle]="'Unlock ' + petName.trim() + '\'s microchip account'"
        [hidePlusFromSubtitle]="true"
        yearlyPrice="£15"
        [hasBuyNow]="true"
        [features]="appPriceCardFeatureText"
        [hideIcon]="true"
        class="indentibase-plus"
      ></app-price-card>

      <app-main-plan-card
        [content]="mainPlanContent"
        [petName]="petName"
        [petType]="petType"
        [thereIsOnlyOneCat]="thereIsOnlyOneCat"
        [isOutdoors]="isOutdoors"
        class="identialer"
        [hideIcon]="true"
        [userCurrentProductType]="userCurrentProductType"
      ></app-main-plan-card>

      <app-price-card
        *ngIf="petType === 1"
        [viewOnly]="false"
        [showShortDescription]="false"
        [showInfoLine]="false"
        [showFeatures]="true"
        [buttonLabel]="'Learn more'"
        [hidePrices]="true"
        (onSelect)="select($event)"
        [planId]="pricingPlans.identiAlertFind"
        [userCurrentProductType]="userCurrentProductType"
        [highlighted]="false"
        [hasBuyNow]="true"
        [hideIcon]="true"
        [features]="[
          'Reel time pet location tracking with a 2-in-1 PitPat GPS tracker',
          'Award-winning activity monitoring to track exercise, distance & rest'
        ]"
        imageUri="/assets/images/pricingTable/identifind.svg"
        planTitle="identifind"
        planShortSubtitle="Everything from identialert"
        planLongSubtitle="Get everything from identialert"
        yearlyPrice="£36"
        [oneOffPrice]="'+£129 one-off payment'"
        class="indentifind"
      ></app-price-card>

      <app-transfer-pet-card *ngIf="petType === 2" class="indentifind"></app-transfer-pet-card>
    </div>

    <div class="d-flex flex-column align-items-center">
      <span *ngIf="!userAlreadyHasASubscription">
        No I don't want to give {{ petName }} pet protection from loss, theft and straying
      </span>
      <a
        [routerLink]="[]"
        queryParamsHandling="preserve"
        (click)="completeMembershipSelection()"
        class="complete-link"
        *ngIf="!userAlreadyHasASubscription"
      >
        Keep basic account
      </a>

      <span *ngIf="userAlreadyHasASubscription">Or continue with your current</span>
      <a
        [routerLink]="[]"
        queryParamsHandling="preserve"
        (click)="continueWithCurrentMembership()"
        class="complete-link"
        *ngIf="userAlreadyHasASubscription"
      >
        {{ currentMembershipName }} membership
      </a>
    </div>
  </div>
</div>
